import { signUpMiddleware } from 'redux/slices/signUp/SignUpApi';
import { currentApiMiddleware } from 'redux/slices/current/CurrentApi';
import { addressApiMiddleware } from 'redux/slices/address/addressApi';
import { shipmentApiMiddleware } from 'redux/slices/shipments/shipmentApi';
import { geoApiMiddleware } from 'redux/slices/geo/geoApi';
import { shipmentReportApiMiddleware } from './slices/reports/reportsApi';
import { currencyApiMiddleware } from 'redux/slices/currency/currencyApi';
import { bookServiceApiMiddleware } from 'redux/slices/bookService/bookServiceApi';
import { serviceTypeApiMiddleware } from 'redux/slices/serviceType/serviceTypeApi';
import { deliveryTypeApiMiddleware } from 'redux/slices/deliveryType/deliveryTypeApi';
import { roleApiMiddleware } from './slices/role/roleApi';
import { definitionApiMiddleware } from './slices/definitions/userDefinitionApi';
import { userInfoApiMiddleware } from './slices/profile/userInfoApi';
import { permissionApiMiddleware } from './slices/permission/permissionApi';
import { documentTypeApiMiddleware } from 'redux/slices/documentType/documentTypeApi';
import { containerTypeApiMiddleware } from 'redux/slices/containerType/containerTypeApi';
import { statusTypeApiMiddleware } from 'redux/slices/statusType/statusTypeApi';
import { phoneCodeApiMiddleware } from 'redux/slices/phoneCode/phoneCodeApi';
import { deliveryMethodApiMiddleware } from './slices/deliveryMethod/deliveryMethodApi';
import { shipmentTrackingMiddleware } from './slices/shipment-tracking/ShipmentTrackingApi';
import { gtipApiMiddleware } from './slices/gtip/gtipApi';
import { pricesApiMiddleware } from 'redux/slices/prices/pricesApi';
const middleware = [
  roleApiMiddleware,
  permissionApiMiddleware,
  serviceTypeApiMiddleware,
  deliveryTypeApiMiddleware,
  deliveryMethodApiMiddleware,
  addressApiMiddleware,
  currencyApiMiddleware,
  bookServiceApiMiddleware,
  currentApiMiddleware,
  signUpMiddleware,
  shipmentApiMiddleware,
  geoApiMiddleware,
  shipmentReportApiMiddleware,
  definitionApiMiddleware,
  userInfoApiMiddleware,
  documentTypeApiMiddleware,
  statusTypeApiMiddleware,
  phoneCodeApiMiddleware,
  containerTypeApiMiddleware,
  shipmentTrackingMiddleware,
  gtipApiMiddleware,
  pricesApiMiddleware,
];

export default middleware;
